var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFileEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M20.5 6.238V6.5h-5.667V1h.27c.284 0 .554.107.753.3l4.334 4.212c.2.193.31.455.31.726zm-6.02 1.637h6.02v14.094c0 .571-.474 1.031-1.063 1.031H4.563c-.588 0-1.062-.46-1.062-1.031V2.03C3.5 1.46 3.974 1 4.563 1h8.854v5.844c0 .567.478 1.031 1.062 1.031zm-2.64 4.71l-4.205 4.081-.24 2.072c-.03.274.209.51.497.48l2.134-.231 4.205-4.082a.213.213 0 000-.31l-2.072-2.01a.226.226 0 00-.318 0zm4.857-1.303l-1.124-1.091a.913.913 0 00-1.266 0l-1.152 1.117a.215.215 0 000 .31l2.072 2.01a.23.23 0 00.32 0l1.15-1.117a.85.85 0 000-1.229z"
  }))));
}

export default SvgFileEdit;